export const ctaOptions = [
  { text: "Install app", id: "INSTALL_MOBILE_APP" },
  { text: "Download", id: "DOWNLOAD" },
  { text: "Book now", id: "BOOK_NOW" },
  { text: "Learn more", id: "LEARN_MORE" },
  { text: "Listen now", id: "LISTEN_NOW" },
  { text: "Play game", id: "PLAY_GAME" },
  { text: "Shop now", id: "SHOP_NOW" },
  { text: "Sign up", id: "SIGN_UP" },
  { text: "Subscribe", id: "SUBSCRIBE" },
  { text: "Use app", id: "USE_MOBILE_APP" },
  { text: "Watch more", id: "WATCH_MORE" }
];
